import { render, staticRenderFns } from "./CounterRating.vue?vue&type=template&id=7e1edd48&"
import script from "./CounterRating.vue?vue&type=script&lang=js&"
export * from "./CounterRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports